import { Box, Divider, Typography, useTheme } from '@material-ui/core';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { strings as Localization } from '../../../lib/Localization';
import { useFilteredProducts, useProductsLoading } from '../../../redux/hook/productHooks';
import Products from '../../Products/Products';
import ProductViewToggleButton from '../../Products/ProductViewToggleButton/ProductViewToggleButton';
import useStyles from './styles';

function FavoriteProductsPage() {
    const classes = useStyles();
    const favoriteProducts = useSelector(state => state.favorite.favoriteProducts);
    const filter = useMemo(() => ({ productIds: favoriteProducts }), [favoriteProducts]);
    const pagination = useMemo(() => ({ offset: 0, limit: -1 }), []);
    const isLoading = useProductsLoading();
    const products = useFilteredProducts(filter, pagination);
    const missingProducts = useMemo(() => (
        favoriteProducts.filter(id => !products.some(product => product.originalId === id))
    ), [favoriteProducts, products])
    const theme = useTheme();

    return (
        <main className={classes.content}>
            <Typography variant='h3' gutterBottom>{Localization.yourFavorites}</Typography>
            <Box className={classes.infoArea}>
                <Box className={classNames(classes.flexColumn, classes.infoText)}>
                    <Typography variant='caption'>{Localization.hereYouWillFindAllFavoriteProducts}</Typography>
                </Box>
            </Box>
            <Box className={classes.listArea}>
                <Box style={{
                    margin: `0 ${theme.spacing(3)}px`,
                    marginTop: theme.spacing(6),
                    display: "flex",
                    justifyContent: "space-between",
                }}>
                    <Typography>
                        {Localization.products.toUpperCase()}
                    </Typography>
                    <ProductViewToggleButton />
                </Box>
                <Divider />
                <Products products={products} missingProducts={isLoading ? [] : missingProducts} />
            </Box>
        </main>
    )
}

export default FavoriteProductsPage;